import {
    GET_PROFILE_REQUEST,
    GET_PROFILE_SUCCESS,
    GET_PROFILE_FAILURE,
    UPDATE_PROFILE_REQUEST,
    UPDATE_PROFILE_SUCCESS,
    UPDATE_PROFILE_FAILURE,
  } from "../actions/AppProfileType"
  
  const initialState = {
    profile: {
      name: "",
      email: "",
      mobile: "",
      username: "",
      role_id: "",
      role_name: "",
    },
    loading: false,
    updating: false,
    error: null,
    updateError: null,
    success: false,
  }
  
  const profileReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_PROFILE_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
          success: false,
        }
  
     case GET_PROFILE_SUCCESS:
     return {
       ...state,
       loading: false,
       profile: {
         name: action.payload?.admin_name || "",
         email: action.payload?.admin_email || "",
         mobile: action.payload?.admin_mobile || "",
         username: action.payload?.admin_username || "",
         role_id: action.payload?.role_id || "",
         role_name: action.payload?.role_name || "",
       },
       error: null,
     }
  
      case GET_PROFILE_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        }
  
      case UPDATE_PROFILE_REQUEST:
        return {
          ...state,
          updating: true,
          updateError: null,
          success: false,
        }
  
      case UPDATE_PROFILE_SUCCESS:
        console.log("Reducer - UPDATE_PROFILE_SUCCESS payload:", action.payload) // Debug log
  
        return {
          ...state,
          updating: false,
          profile: {
            ...state.profile,
            ...action.payload,
          },
          updateError: null,
          success: true,
        }
  
      case UPDATE_PROFILE_FAILURE:
        return {
          ...state,
          updating: false,
          updateError: action.payload,
          success: false,
        }
  
      default:
        return state
    }
  }
  
  export default profileReducer
  